import * as React from "react";
const SvgCalendar20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 18,
        fill: "black",
        viewBox: "0 0 16 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M4 6V4H2v4h12V4h-2v2h-2V4H6v2H4Zm6-4H6V0H4v2H0v16h16V2h-4V0h-2v2Zm-8 8v6h12v-6H2Z",
      clipRule: "evenodd"
    })
  );
export default SvgCalendar20Px;
